import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  inject,
  Optional,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { SalesOrdersService, Status } from '@vendasta/sales-orders';
import { finalize, map, take } from 'rxjs/operators';
import { ORDER_LINK } from './order-link';
import { SalesOrderTableCustomComponentDirective } from './sales-order-table-custom.component';
import { Observable, of } from 'rxjs';
import { SALES_ORDERS_ACCESS_SERVICE_TOKEN } from '../sales-orders-table-access.service';

@Component({
  selector: 'sales-ui-order-id-cell',
  template: `
    <div class="sales-order-actions-cell">
      <ng-container *ngIf="!loading; else loadingTemplate">
        <button mat-icon-button [matMenuTriggerFor]="menuRef"><mat-icon>more_vert</mat-icon></button>
        <mat-menu #menuRef>
          <button mat-menu-item (click)="duplicateOrder()">
            {{ 'FRONTEND.SALES_UI.DUPLICATE' | translate }}
          </button>
          @if (canEditCustomFields$ | async) {
            <button
              mat-menu-item
              [routerLink]="[
                '',
                {
                  outlets: {
                    action: [
                      'partnerId',
                      element.partnerId,
                      'custom-fields',
                      'order',
                      'object',
                      element.businessId + '|' + element.orderId
                    ]
                  }
                }
              ]"
            >
              {{ 'FRONTEND.SALES_UI.EDIT_CUSTOM_FIELDS' | translate }}
            </button>
          }
        </mat-menu>
      </ng-container>
      <ng-template #loadingTemplate>
        <mat-spinner [diameter]="30"></mat-spinner>
      </ng-template>
    </div>
  `,
  styles: [
    `
      .sales-order-actions-cell {
        text-align: center;
      }

      .sales-order-actions-cell .mat-mdc-icon-button {
        height: 30px !important;
        width: 30px !important;
        line-height: 30px !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SalespersonOrderActionsCellComponent extends SalesOrderTableCustomComponentDirective {
  protected readonly status = Status;
  protected loading = false;
  private readonly orderLink = inject(ORDER_LINK);
  protected readonly canEditCustomFields$: Observable<boolean>;

  constructor(
    private salesOrdersService: SalesOrdersService,
    private cdk: ChangeDetectorRef,
    private readonly router: Router,
    @Optional() @Inject(SALES_ORDERS_ACCESS_SERVICE_TOKEN) private readonly accessService,
  ) {
    super();
    this.canEditCustomFields$ = this.accessService?.canModifyCustomFields$
      ? this.accessService.canModifyCustomFields$
      : of(false);
  }

  protected duplicateOrder(): void {
    this.loading = true;
    this.salesOrdersService
      .duplicate(this.element.orderId, this.element.businessId)
      .pipe(
        take(1),
        map((orderId) => {
          const orderRow = this.element;
          orderRow.orderId = orderId;
          const url = this.orderLink(orderRow);
          this.router.navigate([url]);
        }),
        finalize(() => {
          this.loading = false;
          this.cdk.detectChanges();
        }),
      )
      .subscribe();
  }
}
